import { SUBSCRIPTIONS_CUSTOMER_FRESH_CONTROLLER_ROOT_PATH } from "./root";

export const SUBSCRIPTIONS_CUSTOMER_UPDATE_FRESH_RECIPES_PATH_SUFFIX = "/recipes/update";
/** /customer/subscription/fresh/recipes/update */
export const SUBSCRIPTIONS_CUSTOMER_UPDATE_FRESH_RECIPES_PATH = `${SUBSCRIPTIONS_CUSTOMER_FRESH_CONTROLLER_ROOT_PATH}${SUBSCRIPTIONS_CUSTOMER_UPDATE_FRESH_RECIPES_PATH_SUFFIX}`;
